module.exports = "float PI_INV = 0.3183098862;"